"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.19.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FamilyMemberConditionDtoToJSON = exports.FamilyMemberConditionDtoFromJSONTyped = exports.FamilyMemberConditionDtoFromJSON = exports.instanceOfFamilyMemberConditionDto = exports.FamilyMemberConditionDtoAgeAtDiagnosisEnum = exports.FamilyMemberConditionDtoNameEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.FamilyMemberConditionDtoNameEnum = {
    BrainCancer: 'Brain cancer',
    BreastCancer: 'Breast cancer',
    BreastCancersBilateral: 'Breast cancers (bilateral)',
    CervicalCancer: 'Cervical cancer',
    ColonRectalCancer: 'Colon/rectal cancer',
    ColonRectalPolyps: 'Colon/rectal polyps',
    EndometrialUterineCancer: 'Endometrial/uterine cancer',
    GastricStomachCancer: 'Gastric/stomach cancer',
    Melanoma: 'Melanoma',
    OtherCancer: 'Other cancer',
    OvarianCancer: 'Ovarian cancer',
    PancreaticCancer: 'Pancreatic cancer',
    Paraganglioma: 'Paraganglioma',
    ParathyroidCancer: 'Parathyroid cancer',
    Pheochromocytoma: 'Pheochromocytoma',
    ProstateCancer: 'Prostate cancer',
    RenalKidneyCancer: 'Renal/kidney cancer',
    SoftTissueSarcoma: 'Soft tissue sarcoma',
    ThyroidCancer: 'Thyroid cancer',
    UnknownCancer: 'Unknown cancer',
    Null: 'null'
};
/**
 * @export
 */
exports.FamilyMemberConditionDtoAgeAtDiagnosisEnum = {
    _39AndUnder: '39 and under',
    _4044: '40-44',
    _4549: '45-49',
    _50AndOver: '50 and over',
    Null: 'null'
};
/**
 * Check if a given object implements the FamilyMemberConditionDto interface.
 */
function instanceOfFamilyMemberConditionDto(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfFamilyMemberConditionDto = instanceOfFamilyMemberConditionDto;
function FamilyMemberConditionDtoFromJSON(json) {
    return FamilyMemberConditionDtoFromJSONTyped(json, false);
}
exports.FamilyMemberConditionDtoFromJSON = FamilyMemberConditionDtoFromJSON;
function FamilyMemberConditionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'ageAtDiagnosis': !(0, runtime_1.exists)(json, 'ageAtDiagnosis') ? undefined : json['ageAtDiagnosis'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
    };
}
exports.FamilyMemberConditionDtoFromJSONTyped = FamilyMemberConditionDtoFromJSONTyped;
function FamilyMemberConditionDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'ageAtDiagnosis': value.ageAtDiagnosis,
        'description': value.description,
    };
}
exports.FamilyMemberConditionDtoToJSON = FamilyMemberConditionDtoToJSON;
